<div class="paper fax-folder-list">
  <app-fax-filter-list-wrapper title="Folders">
    <ng-container *ngIf="!isLoading; else foldersSkeleton">
      <li *ngFor="let item of items" class="fax-folder-list__item" (click)="selectFolder(item)">
        <img src="assets/icons/folder.svg" class="fax-folder-list__item-icon" />

        {{ item.name }}
      </li>
    </ng-container>

    <ng-template #foldersSkeleton>
      <li *ngFor="let row of skeletonRows" class="fax-folder-list__item fax-folder-list__item_skeleton">
        <span class="skeleton fax-folder-list__item-skeleton"></span>
      </li>
    </ng-template>
  </app-fax-filter-list-wrapper>

  <app-fax-filter-list-form
    [value]="selectedFolderName"
    placeholder="Enter folder name and press &quot;+&quot;"
    [disableCreate]="isFolderSelected"
    (valueChange)="onValueChange($event)"
    (createClick)="createClick.emit($event)"
    (deleteClick)="deleteClick.emit($event)"
  ></app-fax-filter-list-form>
</div>
